import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./auth";
import accountReducer from "./accountSlice"; // Adjust the path as necessary

const store = configureStore({
  reducer: {
    auth: authReducer,
    account: accountReducer,
  },
});

export default store;
